<template>
  <b-card>

    <!-- media -->
    <b-media no-body>
      <b-media-aside>
        <b-link>
          <b-img ref="previewEl" rounded :src="optionsLocal.logo" height="80" />
        </b-link>
        <!--/ avatar -->
      </b-media-aside>

      <b-media-body class="mt-75 ml-75">
        <!-- upload button -->
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="sm" :state="Boolean(file)"
          v-model="file" class="mb-75 mr-75" @click="$refs.refInputEl.$el.click()">
          {{ $t('Upload') }}
        </b-button>
        <b-form-file ref="refInputEl" v-model="profileFile" accept=".jpg, .png, .gif" :hidden="true" plain
          @input="fileSelected" />
        <!--/ upload button -->

        <!-- reset -->
        <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" size="sm" class="mb-75 mr-75">
          {{ $t('Reset') }}
        </b-button>
        <!--/ reset -->
        <b-card-text>{{ $t('Allowed JPG, GIF or PNG. Max size of 800kB') }}</b-card-text>
      </b-media-body>
    </b-media>
    <!--/ media -->

    <!-- form -->
    <b-form class="mt-2">

      <b-row>
        <b-col sm="12">
          <b-form-group :label="$t('Legal Name')" label-for="account-company">
            <b-form-input v-model="optionsLocal.title" name="company" :placeholder="$t('Company name')" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group :label="$t('Account Manager Name')" label-for="account-username">
            <b-form-input v-model="optionsLocal.contactname" :placeholder="$t('Account Manager Name')"
              name="username" />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group :label="$t('Contact Number')" label-for="account-name">
            <b-form-input v-model="optionsLocal.contactphone" name="name" :placeholder="$t('Mobile')" />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group :label="$t('Primary E-mail')" label-for="account-e-mail">
            <b-form-input v-model="optionsLocal.contactmail" name="email" :placeholder="$t('Email')" />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group :label="$t('API KEY')" label-for="account-e-mail">
            {{ apikey }}
          </b-form-group>
        </b-col>

        <!-- alert -->
        <!-- <b-col cols="12" class="mt-75">
          <b-alert show variant="warning" class="mb-50">
            <h4 class="alert-heading">
              Your email is not confirmed. Please check your inbox.
            </h4>
            <div class="alert-body">
              <b-link class="alert-link">
                Resend confirmation
              </b-link>
            </div>
          </b-alert>
        </b-col> -->
        <!--/ alert -->

        <b-col cols="12">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-2 mr-1"
            @click.prevent="sendInformation">
            {{ $t("Save Changes") }}
          </b-button>
          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" type="reset" class="mt-2"
            @click.prevent="resetForm">
            {{ $t('Reset') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BFormFile, BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    apikey() {
      return localStorage.getItem("clientToken");
    },
  },
  created() {
    //console.log("account created");
    this.optionsLocal = JSON.parse(JSON.parse(JSON.stringify(this.generalData.data)).generalsettings);//this.generalData;
    //console.log( this.optionsLocal);
    //console.log("account created");


  },
  data() {
    return {
      optionsLocal: {},// this.generalData.generalsettings,
      profileFile: null,
      file: null,
      isUpdated: false,
      isLoading: false,
    }
  },
  methods: {
    resetForm() {
      this.optionsLocal = this.generalData.generalsettings;
    },
    resetFile() {
      this.file = null;
      this.profileFile = null;
    },
    clearFiles() {
      this.$refs["file-input"].reset();
    },
    fileSelected(payload) {
      const formData = new FormData();
      formData.append("file", payload);
      formData.append("courseId", this.courseId);
      formData.append("acc", 3);
      formData.append("platform", "webadmin");
      this.isLoading = true;

      axios
        .post("/upload/admin", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          //console.log(response);
          this.optionsLocal.logo = response.data.url;
          this.isUpdated = true;
          this.isLoading = false;
          this.$bvToast.toast(`${response.data.message}`, {
            title: "Success",
            autoHideDelay: 5000,
            appendToast: true,
            variant: "success",
            solid: true,
          });
        })
        .catch((error) => {
          //console.log(error);
          this.isLoading = false;
          this.$bvToast.toast(`${error.response.data.message}`, {
            title: "Error",
            autoHideDelay: 5000,
            appendToast: true,
            variant: "danger",
            solid: true,
          });
        });
    },

    sendInformation() {
      //console.log(this.optionsLocal);


      this.isLoading = true;
      axios({
        method: "put",
        url: `/admin/f/settings`,
        data: {
          info: "generalinformation",
          file: null,
          content: this.optionsLocal,
        },
      })
        .then((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "CheckCircleIcon",
              variant: "success",
            },
          });
          this.isLoading = false;
          this.isUpdated = false;
        })
        .catch((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "AlertOctagonIcon",
              variant: "warning",
            },
          });
          this.isLoading = false;
        });
      return;
    },
  },
  setup() {
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl)

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    }
  },
}
</script>
